'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _react = require('react')

var _react2 = _interopRequireDefault(_react)

var _styledComponents = require('styled-components')

var _styledComponents2 = _interopRequireDefault(_styledComponents)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _styledSystem = require('styled-system')

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

var Base = function Base(props) {
  var next = (0, _theme.filterProps)(props)
  return _react2.default.createElement('div', next)
}

var Box = (0, _styledComponents2.default)(Base)(
  [],
  _styledSystem.space,
  _styledSystem.width,
  _styledSystem.color,
  _styledSystem.fontSize,
  _styledSystem.textAlign
)

Box.displayName = 'Box'
Box.header = Box.withComponent('header')
Box.main = Box.withComponent('main')
Box.article = Box.withComponent('article')
Box.section = Box.withComponent('section')
Box.footer = Box.withComponent('footer')

Box.defaultProps = {
  theme: _theme2.default
}

Box.propTypes = _extends(
  {},
  _styledSystem.propTypes.textAlign,
  _styledSystem.propTypes.fontSize,
  _styledSystem.propTypes.space,
  _styledSystem.propTypes.color
)

exports.default = Box



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Box.js
// module id = 26
// module chunks = 168707334958949